import {ResponseError} from "./response-error";
import {contains, equals, hashGet} from "../../helpers/array.helper";
import {ErrorItem} from "./error-item";

export class Response {

  constructor(response) {
    this.response = response.data;
    this.status = response.status;
  }

  _handleErrors (internalPath) {
    const errors = [];
    if (this.response.errors && this.response.errors.length !== 0) {
      for (const e of this.response.errors) {
        if (!contains(internalPath, e.path)) continue;
        errors.push(new ErrorItem(e));
      }
    }
    return errors;
  }

  get(path = '', defaultValue = null) {
    const errors = this._handleErrors(path.split('.'));
    if (errors && errors.length > 0) {
      return new ResponseError(errors);
    }
    return hashGet(this.response.data ? this.response.data : this.response, path, defaultValue);
  }

}



// WEBPACK FOOTER //
// ./src/network/response/response.js